<!--
  This is the view that will be shown when navigating to a workspace that has no folders.
  As soon as the workspace recieves a folder, this view will try to navigate to that folder.
-->

<template>
  <article class="view-workspaceempty">
    <header class="line" style="min-height: 40px">
      <h1 class="m-0">{{ workspaceName }}</h1>
    </header>
    <p>
      {{ $t("messages.emptyWorkspace") }}
    </p>
  </article>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useWorkspaces } from "@/api/workspaces.store";
import { useRoute, useRouter } from "vue-router";

const props = defineProps<{
  organizationSlug: string;
  teamSlug: string;
}>();

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const { currentWorkspace, currentWorkspaceFolders } = useWorkspaces(props);

const workspaceName = computed(() => {
  if (currentWorkspace.value?.organizationSlug) {
    return currentWorkspace.value.name;
  } else {
    return t("labels.personalWorkspace");
  }
});

watch(() => currentWorkspaceFolders.value.length, (newLength) => {
  if (newLength == 0) {
    return;
  }

  const firstFolder = currentWorkspaceFolders.value?.[0];
  let path = route.path;
  if (path.substring(-1) === "/") path = path.substring(0, -1);
  router.replace({
    path: path + `/${firstFolder.slug}`
  });
}, { immediate: true });
</script>

<style lang="scss">
.view-workspaceempty {
  display: block;
  overflow: auto;
  width: 100%;
  max-width: 60rem;
  min-width: 0;
  margin: 0 auto;
}
</style>
